import { OrderType } from '~/enums'

/** Group Dining is the `dine_in` order type, the only one that asks the customer for a party size. */
export const isGroupDining = (orderType: OrderType): boolean => orderType === OrderType.DINE_IN
